module.exports = __webpack_public_path__ + "img/Slide9.efafecea.png";